import type { JSX } from 'react';

import type { CurrentSession } from './api';
import { authUrl } from './api';

export interface SessionPanelProps {
  readonly session: CurrentSession | null;
  readonly loading: boolean;
  readonly error: string | null;
  readonly onLogout: () => void;
}

/** Reine Ansicht, damit der vorhandene Node-Renderer als Test genügt. */
export function SessionPanel({
  session,
  loading,
  error,
  onLogout,
}: SessionPanelProps): JSX.Element {
  if (loading) {
    return <p>Sitzung wird geprüft …</p>;
  }

  if (session === null) {
    return (
      <section>
        <p>Melden Sie sich mit Ihrem Firmenkonto an.</p>
        {error === null ? null : <p role="alert">{error}</p>}
        <a href={authUrl('login')}>Anmelden mit Microsoft</a>
      </section>
    );
  }

  return (
    <section>
      <p>Angemeldet als {session.name}</p>
      {error === null ? null : <p role="alert">{error}</p>}
      <button type="button" onClick={onLogout}>
        Abmelden
      </button>
    </section>
  );
}
